import type { CSSProperties } from 'react';

/**
 * A style object that may also carry custom properties. Components pass token
 * references down as `--dpem-*` variables instead of branching into a class per
 * classification: one CSS rule, N meanings, and the value is still a live
 * `var(--c-…)` reference so the cascade (and a later theme swap) still applies.
 */
export type StyleWithVars = CSSProperties & Record<`--${string}`, string | number>;

/** Merge an author-supplied style over component-owned custom properties. */
export const mergeStyle = (
  own: StyleWithVars,
  incoming: CSSProperties | undefined,
): StyleWithVars => (incoming === undefined ? own : { ...own, ...incoming });
